export const LEVELMETER = 'Levelmeter';
export const LEVELMETERVW = 'Levelmetervw';
export const WATERLEVEL = 'Water level';
export const TEMPR = 'Tempr';
export const AIRTEMPERATURE = 'Air temperature';
export const AIRSPEED = 'Airspeed';
export const AIRDIRECTION = 'Airdirection';
export const WINDSPEED = 'Wind speed';
export const WINDDIRECTION = 'Wind direction';
export const RAIN = 'Rain';
export const PRECIPITATION = 'Precipitation';
export const BATTERYI = 'Batteryi';
export const BATTERYV = 'Batteryv';
export const SOLARFLUXDENSITY ='Solar flux density';
export const SOLARFLUXDENSITY2 ='Solarfluxdensity';
export const RELATIVEHUMIDITY = 'Relative humidity';
export const RELATIVEHUMIDITY2 = 'Relativehumidity';
export const PRESSUREABSOLUTE = 'Barometric pressure absolute';
export const PRESSUREABSOLUTE2 = 'Pressureabsolute';
export const PRESSURERELATIVE = 'Barometric pressure relative';
export const PRESSURERELATIVE2 = 'Pressurerelative';
export const VAPORPRESSURE = 'Vapor pressure';
export const VAPORPRESSURE2 = 'Vaporpressure';
export const STRIKEDISTANCE = 'Strike distance';
export const STRIKEDISTANCE2 = 'Strikedistance';
export const STRIKECOUNT = 'Lightning strike count';
export const STRIKECOUNT2 = 'Strikecount';
export const HUMIDITYTEMP = 'Humidity sensor temperature';
export const HUMIDITYTEMP2 = 'Humiditysensortempr';
export const GUST = 'Wind speed max. 10 s gust';
export const GUST2 = 'Windspeedmax10sgust';
export const TILTNORTH = 'Tilt north';
export const TILTEAST = 'Tilt east';
export const TILTWEST = 'Tilt west';
export const TILTSOUTH = 'Tilt south';
export const TILTNS = 'Tiltns';
export const TILTWE = 'Tiltwe';
export const SOLARI = 'Solari';
export const SOLARV = 'Solarv';
export const PIEZOMETER = 'Piezometer';
export const PIEZOMETERVW = 'Piezometervw';
export const INCLINOMETER = 'Inclinometer';
export const INCLINOMETERRST = 'Inclinometerrst';



export const levelMeters = [
    LEVELMETER,
    WATERLEVEL,
    LEVELMETERVW,
];

export const iconsInPanel = [
    TEMPR,
    LEVELMETER,
    LEVELMETERVW,
    AIRSPEED,
    AIRDIRECTION,
    RAIN,
    AIRTEMPERATURE,
    PRECIPITATION,
    WINDSPEED,
    WINDDIRECTION,
    WATERLEVEL
];

// used in controller charts and others
// commented out ones are not shown at all (should search for better solution, switch)
// NOTE: HUMIDITYTEMP and HUMIDITYTEMP2 are not included as they are added in relative humidity chart
export const sensorsGraphics = [
    LEVELMETER,
    LEVELMETERVW,
    WATERLEVEL,
    TEMPR,
    AIRTEMPERATURE,
    AIRSPEED,
    AIRDIRECTION,
    WINDSPEED,
    WINDDIRECTION,
    RAIN,
    PRECIPITATION,
    BATTERYI,
    BATTERYV,
    SOLARFLUXDENSITY,
    SOLARFLUXDENSITY2,
    RELATIVEHUMIDITY,
    RELATIVEHUMIDITY2,
    PRESSUREABSOLUTE,
    PRESSUREABSOLUTE2,
    PRESSURERELATIVE,
    PRESSURERELATIVE2,
    TILTEAST,
    VAPORPRESSURE,
    VAPORPRESSURE2,
    STRIKEDISTANCE,
    STRIKEDISTANCE2,
    STRIKECOUNT,
    STRIKECOUNT2,
    GUST,
    GUST2,
    TILTNORTH,
    TILTSOUTH,
    TILTWEST,
    TILTNS,
    TILTWE,
    SOLARI,
    SOLARV
];

// used in the analysis modal (custom subset)
export const analysisGraphics = [
    ...levelMeters,
    RAIN,
    PRECIPITATION,
    PIEZOMETER,
    PIEZOMETERVW
];

// which icons to be shown in map info window popup
export const popupIcons = [
    LEVELMETER,
    LEVELMETERVW,
    WATERLEVEL,
    TEMPR,
    AIRTEMPERATURE,
    AIRSPEED,
    AIRDIRECTION,
    WINDSPEED,
    WINDDIRECTION,
    RAIN,
    PRECIPITATION,
    BATTERYI,
    BATTERYV,
    SOLARFLUXDENSITY,
    SOLARFLUXDENSITY2,
    RELATIVEHUMIDITY,
    RELATIVEHUMIDITY2,
    PRESSUREABSOLUTE,
    PRESSUREABSOLUTE2,
    PRESSURERELATIVE,
    PRESSURERELATIVE2,
    TILTEAST,
    VAPORPRESSURE,
    VAPORPRESSURE2,
    STRIKEDISTANCE,
    STRIKEDISTANCE2,
    STRIKECOUNT,
    STRIKECOUNT2,
    HUMIDITYTEMP,
    HUMIDITYTEMP2,
    GUST,
    GUST2,
    TILTNORTH,
    TILTWEST,
    TILTSOUTH,
    TILTNS,
    TILTWE
];

export const iconsUnits = {
    [BATTERYI]: {
        icon: 'battery',
        altIcon: 'battery-half',
        unit: 'units.amper',
    },
    [SOLARI]: {
        icon: 'solarFluxDensity',
        altIcon: 'battery-half',
        unit: 'units.amper',
    },
    [SOLARV]: {
        icon: 'solarFluxDensity',
        altIcon: 'battery-half',
        unit: 'units.volt',
    },
    [SOLARFLUXDENSITY]: {
        icon: 'solarFluxDensity',
        altIcon: 'brightness-high',
        unit: 'units.solar'
    },
    [SOLARFLUXDENSITY2]: {
        icon: 'solarFluxDensity',
        altIcon: 'brightness-high',
        unit: 'units.solar'
    },
    [PRECIPITATION]: {
        icon: 'rain',
        altIcon: 'cloud',
        unit: 'units.liters-hour'
    },
    [WINDDIRECTION]: {
        icon: 'wind',
        altIcon: 'flag',
        unit: ''
    },
    [RELATIVEHUMIDITY]: {
        icon: 'relativeHumidity',
        altIcon: 'droplet',
        unit: 'units.humidity'
    },
    [RELATIVEHUMIDITY2]: {
        icon: 'relativeHumidity',
        altIcon: 'droplet',
        unit: 'units.humidity'
    },
    [PRESSUREABSOLUTE]: {
        icon: 'barometricPressure',
        altIcon: 'flag',
        unit: 'units.hPa'
    },
    [PRESSUREABSOLUTE2]: {
        icon: 'barometricPressure',
        altIcon: 'flag',
        unit: 'units.hPa'
    },
    [TILTEAST]: {
        icon: 'inclinometer',
        altIcon: 'chevron-double-right',
        unit: 'units.angle'
    },
    [PRESSURERELATIVE]: {
        icon: 'barometricPressure',
        altIcon: 'flag-fill',
        unit: 'units.hPa'
    },
    [PRESSURERELATIVE2]: {
        icon: 'barometricPressure',
        altIcon: 'flag-fill',
        unit: 'units.hPa'
    },
    [VAPORPRESSURE]: {
        icon: 'barometricPressure',
        altIcon: 'arrow-down',
        unit: ''
    },
    [VAPORPRESSURE2]: {
        icon: 'barometricPressure',
        altIcon: 'arrow-down',
        unit: ''
    },
    [STRIKEDISTANCE]: {
        icon: 'lightningStrikeCount',
        altIcon: 'map',
        unit: 'units.km'
    },
    [STRIKEDISTANCE2]: {
        icon: 'lightningStrikeCount',
        altIcon: 'map',
        unit: 'units.km'
    },
    [BATTERYV]: {
        icon: 'battery',
        altIcon: 'battery-half',
        unit: 'units.volt'
    },
    [AIRTEMPERATURE]: {
        icon: 'temperature',
        altIcon: 'thermometer',
        unit: 'units.degrees'
    },
    [GUST]: {
        icon: 'wind',
        altIcon: 'flag',
        unit: 'units.meters-second'
    },
    [GUST2]: {
        icon: 'wind',
        altIcon: 'flag',
        unit: 'units.meters-second'
    },
    "Address": {
        icon: '',
        altIcon: 'house',
        unit: ''
    },
    [WINDSPEED]: {
        icon: 'wind',
        altIcon: 'flag-fill',
        unit: 'units.meters-second'
    },
    [STRIKECOUNT]: {
        icon: 'lightningStrikeCount',
        altIcon: 'sort-numeric-up',
        unit: 'units.number'
    },
    [STRIKECOUNT2]: {
        icon: 'lightningStrikeCount',
        altIcon: 'sort-numeric-up',
        unit: 'units.number'
    },
    [HUMIDITYTEMP]: {
        icon: 'relativeHumidity',
        altIcon: 'thermometer',
        unit: 'units.degrees'
    },
    [HUMIDITYTEMP2]: {
        icon: 'relativeHumidity',
        altIcon: 'thermometer',
        unit: 'units.degrees'
    },
    [TILTNORTH]: {
        icon: 'inclinometer',
        altIcon: 'chevron-double-up',
        unit: 'units.angle'
    },
    [TILTWEST]: {
        icon: 'inclinometer',
        altIcon: 'chevron-double-up',
        unit: 'units.angle'
    },
    [TILTSOUTH]: {
        icon: 'inclinometer',
        altIcon: 'chevron-double-up',
        unit: 'units.angle'
    },
    [TILTNS]: {
        icon: 'inclinometer',
        altIcon: 'chevron-double-up',
        unit: 'units.angle'
    },
    [TILTWE]: {
        icon: 'inclinometer',
        altIcon: 'chevron-double-up',
        unit: 'units.angle'
    },
    "Piezometer1": {
        icon: 'piezometer',
        altIcon: 'inclinometer',
        unit: 'units.kPa'
    },
    "Piezometer2": {
        icon: 'piezometer',
        altIcon: 'inclinometer',
        unit: 'units.kPa'
    },
    "Piezometer3": {
        icon: 'piezometer',
        altIcon: 'inclinometer',
        unit: 'units.kPa'
    },
    "Piezometer4": {
        icon: 'piezometer',
        altIcon: 'inclinometer',
        unit: 'units.kPa'
    },
    "Piezometer5": {
        icon: 'piezometer',
        altIcon: 'inclinometer',
        unit: 'units.kPa'
    },
    "Piezometer6": {
        icon: 'piezometer',
        altIcon: 'inclinometer',
        unit: 'units.kPa'
    },
    [TEMPR]: {
        icon: 'temperature',
        altIcon: 'thermometer',
        unit: "units.degrees"
    },
    [AIRDIRECTION]: {
        icon: 'wind',
        altIcon: 'flag',
        unit: ''
    },
    [AIRSPEED]: {
        icon: 'wind',
        altIcon: 'flag',
        unit: 'units.meters-second'
    },
    [RAIN]: {
        icon: 'rain',
        altIcon: 'droplet',
        unit: 'units.liters-hour'
    },
    [INCLINOMETER]:  {
        icon: 'inclinometer',
        altIcon: '',
        unit: 'units.mm-m'
    },
    [INCLINOMETERRST]:  {
        icon: 'inclinometer',
        altIcon: '',
        unit: 'units.mm-m'
    },
    [PIEZOMETERVW]: {
        icon: 'piezometer',
        altIcon: 'inclinometer',
        unit: 'units.kPa'
    },
    "Piezometervw1": {
        icon: 'piezometer',
        altIcon: 'inclinometer',
        unit: 'units.kPa'
    },
    "Piezometervw2": {
        icon: 'piezometer',
        altIcon: 'inclinometer',
        unit: 'units.kPa'
    },
    "Piezometervw3": {
        icon: 'piezometer',
        altIcon: 'inclinometer',
        unit: 'units.kPa'
    },
    "Piezometervw4": {
        icon: 'piezometer',
        altIcon: 'inclinometer',
        unit: 'units.kPa'
    },
    "Piezometervw5": {
        icon: 'piezometer',
        altIcon: 'inclinometer',
        unit: 'units.kPa'
    },
    "Piezometervw6": {
        icon: 'piezometer',
        altIcon: 'inclinometer',
        unit: 'units.kPa'
    },
    [LEVELMETERVW]:  {
        icon: 'water-level',
        altIcon: 'distribute-vertical',
        unit: 'units.meters'
    },
    "Levelmetervw1":  {
        icon: 'water-level',
        altIcon: 'distribute-vertical',
        unit: 'units.meters'
    },
    [LEVELMETER]:  {
        icon: 'water-level',
        altIcon: 'distribute-vertical',
        unit: 'units.meters'
    },
    [WATERLEVEL]:  {
        icon: 'water-level',
        altIcon: 'distribute-vertical',
        unit: 'units.meters'
    }
};

export const sensorsTableMap = {
    controller: 1,
    piezometer: 2,
    inclinometer: 3,
    levelmeter: 4,
    profile: 5,
    overview: 6
};

export const sensorTabsAndProfileLen = Object.keys(sensorsTableMap).length;

export const autoStartSensors = [
    INCLINOMETER, INCLINOMETERRST, PIEZOMETER, PIEZOMETERVW,
    TEMPR, AIRTEMPERATURE, RAIN, PRECIPITATION, AIRSPEED, WINDSPEED,
    AIRDIRECTION, WINDDIRECTION, ...levelMeters];

export const autoStartTimeFrame = 3;  // months

export const precipitationSensors = [
    PRECIPITATION,
    RAIN
];

export const showTripleDataSensors = [AIRSPEED, WINDSPEED, TEMPR, AIRTEMPERATURE];

export const showPlotLineFor = [LEVELMETER, LEVELMETERVW, WATERLEVEL];

export const excludedSensors = [PRESSUREABSOLUTE, PRESSUREABSOLUTE2, VAPORPRESSURE, VAPORPRESSURE2,
                                TILTNORTH, TILTEAST, TILTSOUTH, TILTWEST, TILTNS, TILTWE,
                                SOLARI, SOLARV, BATTERYI, BATTERYV];

export const hideZoomIconFor = [WINDDIRECTION, AIRDIRECTION];

// used in translation
export const minString = "min";
export const maxtring = "max";
export const avgString = "avg";
export const litersPerHour = "l/h";
export const litersPerDay = "l/24h"

export const ABSOLUTE = 'absolute';

export const NO_CURRENT_VALUE_CHARTS = [STRIKECOUNT, STRIKECOUNT2, INCLINOMETER, INCLINOMETERRST];